
// due to deprecated of btoa, atob function
// export function encrypt(token: string): string {
//     return btoa(btoa(token)).replace(/=/g, '')
// }

// export function decrypt(token: string): string {
//     return atob(atob(token))
// }
// typescript prefer buffer

/**
 * Encode to base64
 * @param content : text need to encode
 * @returns encoded text in base64
 */
export const encodeBase64 = (content: string): string => {
    return Buffer.from(content).toString('base64').replace(/=/g, '')
}

/**
 * Decode text from base64
 * @param content : text need to decode
 * @returns decoded text from base64
 */
export const decodeBase64 = (content: string): string => {
    return Buffer.from(content, 'base64').toString('ascii')
}

export function decrypt(token: string): string {
    if (typeof atob === 'function') {
        return atob(atob(token))
    }

    const nodeAtob = function (str: string) {
        return Buffer.from(str, 'base64').toString('binary')
    }

    return nodeAtob(nodeAtob(token))
}
